var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 9.33317C14.6667 10.8065 13.4734 11.9998 12.0001 11.9998C10.5267 11.9998 9.33341 10.8065 9.33341 9.33317C9.33341 7.85984 10.5267 6.6665 12.0001 6.6665C13.4734 6.6665 14.6667 7.85984 14.6667 9.33317ZM6.66675 15.9998C6.66675 14.2265 10.2201 13.3332 12.0001 13.3332C13.7801 13.3332 17.3334 14.2265 17.3334 15.9998V16.6665C17.3334 17.0332 17.0334 17.3332 16.6667 17.3332H7.33341C6.96675 17.3332 6.66675 17.0332 6.66675 16.6665V15.9998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#343434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.756aa1da3ed0f1a003601c148fe486c3.svg";
export { ForwardRef as ReactComponent };